import InfiniteScroll from 'react-infinite-scroll-component';
import { ClbLoading } from '@celebration/react/ClbLoading/ClbLoading';
import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import ICarriersResponse from '../../interfaces/ICarriersResponse';
import CarrierCard from '../carrier-card';
import ICarriersListProps from './interfaces/ICarriersListProps';

function CarriersList({
    carriersList,
    fetchNextPageCallback,
    hasMoreRef,
    hasError,
    handleCarrierCheckboxCallback,
    deleteCarrierCallback,
    editCarrierCallback,
}: Readonly<ICarriersListProps>) {
    const { t } = useTranslation();

    const carrierListMessage = useMemo(() => {
        if (hasError) {
            return <h2>{t('TransportadoraErroConsultar')}</h2>;
        }
        if (carriersList.length > 0) {
            return <h2>{t('TransportadorasJaExibidas')}</h2>;
        }

        return <h2>{t('TransportadoraExibirNenhuma')}</h2>;
    }, [carriersList.length, hasError, t]);

    return (
        <InfiniteScroll
            className="card-list"
            dataLength={carriersList.length}
            next={fetchNextPageCallback}
            hasMore={hasMoreRef.current}
            loader={<ClbLoading />}
            endMessage={carrierListMessage}
            data-testid="infinite-scroll"
        >
            {carriersList?.map((carrier: ICarriersResponse) => (
                <CarrierCard
                    key={carrier.id}
                    carrier={carrier}
                    handleCarrierCheckboxCallback={
                        handleCarrierCheckboxCallback
                    }
                    deleteCarrierCallback={deleteCarrierCallback}
                    editCarrierCallback={editCarrierCallback}
                />
            ))}
        </InfiniteScroll>
    );
}

export default CarriersList;
